/* Mega menu hover image: hovering (or focusing) a submenu link overlays the mega menu's
   own image (Image / Featured product / Featured collection / Promo banner block) with
   the matching Hover image block's image, in place — see snippets/header-block-hover-image.liquid,
   injected inside each of those blocks' own image containers. Leaving the dropdown clears
   the overlay, revealing that block's own image again. */

(function () {
  'use strict';

  var selectors = {
    dropdown: '.header__dropdown__inner',
    grandparent: '.grandparent',
    links: '.header__grandparent__links [data-hover-key]',
    overlays: '.hover-image__overlay[data-hover-key]',
  };

  function setActive(overlays, key) {
    overlays.forEach(function (overlay) {
      overlay.classList.toggle('is-active', key !== null && overlay.getAttribute('data-hover-key') === key);
    });
  }

  function initDropdown(dropdown) {
    if (dropdown.hasAttribute('data-hover-image-initialized')) return;

    var overlays = dropdown.querySelectorAll(selectors.overlays);
    if (!overlays.length) return;

    dropdown.setAttribute('data-hover-image-initialized', 'true');

    var links = dropdown.querySelectorAll(selectors.links);
    links.forEach(function (link) {
      var key = link.getAttribute('data-hover-key');
      link.addEventListener('mouseenter', function () {
        setActive(overlays, key);
      });
      link.addEventListener('focus', function () {
        setActive(overlays, key);
      });
    });

    var grandparent = dropdown.closest(selectors.grandparent);
    if (grandparent) {
      grandparent.addEventListener('mouseleave', function () {
        setActive(overlays, null);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(selectors.dropdown).forEach(initDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
